const initFilter = () => {
    const filterInput = document.querySelector("[data-input-filter]");
    const itemsToFilterList = document.querySelectorAll("[data-item-toggle]");
    const itemsTitleToFilterList = document.querySelectorAll("[data-item-filter]");
    if (filterInput) {
        filterInput.addEventListener("keyup", (e) => {
            const inputText = e.target.value.toLowerCase();
            for (let i = 0; i < itemsTitleToFilterList.length; i++) {
                if (itemsTitleToFilterList[i].innerText.toLowerCase().includes(inputText)) {
                    itemsToFilterList[i].setAttribute("data-item-toggle", "hide");
                }
                else {
                    itemsToFilterList[i].setAttribute("data-item-toggle", "show");
                }
            }
        });
    }
};
